// 
export const ADMIN_CLIENT_ID = process.env.REACT_APP_ADMIN_CLIENT_ID
export const ADMIN_GRANT_TYPE = process.env.REACT_APP_ADMIN_GRANT_TYPE
export const ADMIN_CLIENT_SECRET = process.env.REACT_APP_ADMIN_CLIENT_SECRET
export const ADMIN_TOKEN_TYPE = process.env.REACT_APP_ADMIN_TOKEN_TYPE
export const API_URL = process.env.REACT_APP_API_URL
